import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=5a8b6e8c&"
import script from "./Administration.vue?vue&type=script&lang=ts&"
export * from "./Administration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports